import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { ReactComponent as Mailicon } from "../logos/common/iconmail.svg";
import { ReactComponent as Callicon } from "../logos/common/callicon.svg";
import { TwoHeading } from "../general/TwoHeading";
import { OrangeButton } from "../general/OrangeButton";
import * as theme from "../theme";
import Modal from "react-modal";
import {
  binderLetterModalOpened,
  getRecentQuotes,
  getRecentQuotesArray,
} from "../store/components";
import { certificateDataClear, certificateFalg } from "../store/certificate";
import {
  addTransaction,
  getTransactions,
  getTransactionsInformation,
} from "../store/transactions";
import {
  getArrayOfProspectsId,
  getClientDetailsUsingProspectId,
  getGettingMyBinders,
  getGettingMyBindersSuccess,
  getMyBinders,
  getBinderDetails,
  getSelectedBinderDetails,
  getStatus,
  getBrokers,
  getVertical,
  getFilteredProspectsIdArray,
  searchProspects,
  getSearchedProspectsArray,
  getBinderPolicies,
  getSelectedBinderPolicy,
  getIsLoading,
  binderLetterNull,
} from "../store/mybinder";
import {
  bindModalOpened,
  certificateModalOpened,
  additionalModalOpened,
  isBinderLetterModalState,
  getAdditionalModalState,
  getCertificateModalState,
} from "../store/components";
import CertificateModal from "./CertificateInsurerCoverSelection/CertificateModal";
import AdditionalInsuredsModal from "../components/AdditionalInsuredsModal";
import {
  getIRS,
  getIRSAPP,
  getIRSCodeOnly,
  getProspectid,
  getSelectedInsurerEmails,
  getShowingSendToInsurers,
  getStiEmailData,
  getResponseDetails,
  getTotalSelected,
  updateSTCModalStatus,
  getSTCModalStatus,
} from "../store/quotes";
import AddEditBinder from "../general/AddEditBinder";
import ViewCertificate from "./ViewCertificate";
import {
  getMyQuotes,
  getRowDetailsFromProspectId,
  getBinderDetailsUsingProspectId,
} from "../store/myquotes";
import Loader3Orange from "../general/Loader3Orange";
import {
  changeScrollDivResponse,
  getScrollResponsesDiv,
} from "../store/quotes";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import NormalText from "../general/NormalText";
import { PossibleClientDetailsStatus } from "../store/helperfuncs";
import { activateNavigationPage, getLanguageCode } from "../store/components";
import moment from "moment";
import { PossibleNaviationPages } from "./Navigation";
import Typography from "@material-ui/core/Typography";
import { Button, TextareaAutosize, TextField } from "@material-ui/core";
import { useLocation, useNavigate } from "react-router-dom";
import ActionButton from "../general/ActionButton";
import Select from "react-dropdown-select";
import {
  getPolicyStatusData,
  getStatusApi,
  updatePolicyStatusApi,
} from "../store/policyStatus";
import { toast } from "react-toastify";
import ActionCentreText from "../general/ActionCetreText";
import ActionMessageButton from "../general/ActionMessageButton";
import CheckForInvalidLink from "../general/CheckForInvalidLink";
import certificate from "../store/certificate";
import { allCertificateHolderList } from "../store/certificate";
import BindLetterModal from "./BinderLetterModalCoverSelection/CertificateInsurerCoverSelection/BindLetterModal";
import { getBrokerInformation } from "../store/broker";

const translations = {
  en: {
    form: {
      generalBindInformation: "General Bind Information",
      financials: "Financials",
      insurerLabel: "Insurer *",
      bindNumberLabel: "Bind Number",
      quoteReferenceLabel: "Quote Reference *",
      effectiveDateLabel: "Effective Date",
      expiryDateLabel: "Expiry Date *",
      paymentMethodLabel: "Payment Method *",
      premiumLabel: "Premium",
      insurerFeesLabel: "Insurer Fees *",
      brokerFeesLabel: "Broker Fees",
      premiumAndFeesLabel: "Premium & Fees *",
      taxRateApplicableLabel: "Tax rate applicable (%)",
      taxesPayableLabel: "Taxes payable",
      commissionRateLabel: "Commission rate (%)",
      commissionEarnedLabel: "Commission earned",
      selectPaymentMethodPlaceholder: "Select a payment method",
      prospectInformation: "Prospect Information",
      clientName: "Client Name",
      contactName: "Contact Name",
      vertical: "Vertical",
      contactNumber: "Contact Number",
      brokerOwner: "Broker Owner",
      contactEmail: "Contact Email",
      filters: "Filters",
      date: "Date",
      status: "Status",
      clearFilters: "Clear Filters",
      searchForClient: "Search for a Client",
      transactionHistory: "transactionHistory",
      user: "User",
      type: "Type",
      comments: "Comments",
      download: "Download",
      insurer: "insurer",

      // Add more form-related translations as needed
    },
    actions: {
      addComments: {
        text: "Add comments or other information to this prospect file",
        buttonText: "Add Comment",
      },
      checkInsurerResponses: {
        text: "Check to see how insurers are responding to any applications sent out",
        buttonText: "Digital Marketing Hub",
      },
      continueAmendProspect: {
        text: "Continue where you left off or amend prospect information for quotations",
        buttonText: "Go to Application",
      },
      closeProspect: {
        text: "Close this prospect for now, but set-up a review next year",
        buttonText: "Update Status",
      },
    },

    modal: {
      normalText: {
        selectStatusAndComment: "Please select a status and enter comment",
        enterComment: "Please enter a comment",
      },
      selectStatusPlaceholder: "Select a status",
      textareaPlaceholder: "Enter a comment",
      actionButtons: {
        save: "Save",
        cancel: "Cancel",
      },
    },
    binderInformation: "Binder Information",
    binderNumber: "Binder Number",
    certificates: "Certificates",
    sideActions: {
      addEditAdditionalInsureds:
        "Add or Edit Additional Insureds or Loss Payees on this policy",
      additionalInsureds: "Additional Insureds",
      createBinderLetter:
        "Create a letter to client confirming key binder information.",
      createBinderLetterButton: "Create binder letter",
      createCertificate:
        "Create a certificate for your client with a few clicks.",
      createCertificateButton: "Create Certificate",
      viewManageCertificates:
        "View and manage all certificates for this client.",
      binderSummary: "Binder Summary",
      certificateHub: "Certificate Hub",
      visitApplication: "Visit the Application to make any updates or changes.",
      goToApplication: "Go to Application",
      reviewTransactions: "Review any transactions that may have taken place.",
      goToTransactionsAndDocuments: "Go to Transactions and Documents",
    },
    status: "Status",
  },
  fr: {
    status: "Statut",
    binderNumber: "Numéro de classeur",
    certificates: "Certificats",
    binderInformation: "Informations sur le classeur",
    form: {
      generalBindInformation: "Informations Générales de Liaison",
      financials: "Financiers",
      insurerLabel: "Assureur *",
      bindNumberLabel: "Numéro de Liaison",
      quoteReferenceLabel: "Référence de Devis *",
      effectiveDateLabel: "Date effective",
      expiryDateLabel: "Date d'Expiration *",
      paymentMethodLabel: "Méthode de Paiement *",
      premiumLabel: "Prime",
      insurerFeesLabel: "Frais de l'Assureur *",
      brokerFeesLabel: "Frais de Courtier",
      premiumAndFeesLabel: "Prime & Frais *",
      taxRateApplicableLabel: "Taux de taxe applicable (%)",
      taxesPayableLabel: "Taxes Payables",
      commissionRateLabel: "Taux de Commission (%)",
      commissionEarnedLabel: "Commission Gagnée",
      selectPaymentMethodPlaceholder: "Sélectionnez une méthode de paiement",
      prospectInformation: "Informations sur le client potentiel",
      clientName: "Nom du Client",
      contactName: "Nom du Contact",
      vertical: "Secteur d’activités​",
      contactNumber: "Numéro de Contact",
      brokerOwner: "Propriétaire du Courtier",
      contactEmail: "Email du Contact",
      filters: "Filtres",
      date: "Date",
      status: "Statut",
      clearFilters: "Effacer les Filtres",
      searchForClient: "Rechercher un Client",
      transactionHistory: "Historique des transactions",
      user: "Utilisateur",
      type: "Statut",
      comments: "Commentaires",
      download: "Téléchargement",
      insurer: "Assureur",
      // Add more form-related translations as needed
    },

    actions: {
      addComments: {
        text: "Ajouter des commentaires ou d'autres informations au dossier de ce prospect",
        buttonText: "Ajouter un Commentaire",
      },
      checkInsurerResponses: {
        text: "Vérifiez comment les assureurs répondent aux demandes envoyées",
        buttonText: "Plate-forme numérique",
      },
      continueAmendProspect: {
        text: "Continuez là où vous vous êtes arrêté ou modifiez les informations du prospect pour les devis",
        buttonText: "Réviser / Poursuivre",
      },
      closeProspect: {
        text: "Fermer ce prospect pour le moment, mais planifier une révision l'année prochaine",
        buttonText: "Mettre à jour le statut",
      },
    },

    modal: {
      normalText: {
        selectStatusAndComment:
          "Veuillez sélectionner un statut et entrer un commentaire",
        enterComment: "Veuillez entrer un commentaire",
      },
      selectStatusPlaceholder: "Sélectionnez un statut",
      textareaPlaceholder: "Entrez un commentaire",
      actionButtons: {
        save: "Enregistrer",
        cancel: "Annuler",
      },
    },
    sideActions: {
      addEditAdditionalInsureds:
        "Ajouter des commentaires ou d'autres informations à ce dossier de client potentiel​",
      additionalInsureds: "Assurés supplémentaires",
      createBinderLetter:
        "Centre de suivi des demandes transmises aux assureurs​",
      createBinderLetterButton: "Créer une lettre de mandataire",
      createCertificate:
        "Créer un certificat pour votre client en quelques clics.",
      createCertificateButton: "Créer le Certificat",
      viewManageCertificates:
        "Voir et gérer tous les certificats pour ce client.",
      binderSummary: "Résumé du Mandataire",
      certificateHub: "Centre des Certificats",
      visitApplication:
        "Visitez l'Application pour apporter des mises à jour ou des modifications.",
      goToApplication: "Aller à l'Application",
      reviewTransactions: "Réviser toute transaction qui a pu avoir lieu.",
      goToTransactionsAndDocuments: "Aller aux Transactions et Documents",
    },
  },
};

const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);
const BinderZoom = () => {
  const dispatch = useDispatch();
  const search = useLocation().search;
  var code = new URLSearchParams(search).get("id");
  const isLoading = useSelector(getIsLoading);
  const [viewCertificate, setViewCertificate] = useState(false);

  useEffect(() => {
    const binderId = window.location.href.split("=").slice(-1)[0];
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.mypolicies })
    );
    dispatch(getBinderDetails({ policyid: binderId }));
    dispatch(getBinderPolicies(binderId));
    dispatch(getStatusApi());
  }, [dispatch]);

  const binderDetails = useSelector(getSelectedBinderDetails);
  let valid = false;
  if (code && code.length >= 24) valid = true;

  return (
    <GeneralAuthentication>
      {isLoading === true ? (
        <Loader3Orange></Loader3Orange>
      ) : (
        <MainPane hideHelpOrTip={true}>
          <TwoPanesPanel
            myquotesscreen={true}
            myquotesleftpane={
              <CheckForInvalidLink valid={valid}>
                <ProspectZoomLeftPane
                  prospectid={code}
                  setCertificate={setViewCertificate}
                  viewCertificate={viewCertificate}
                ></ProspectZoomLeftPane>
                {viewCertificate ? (
                  <ViewCertificate></ViewCertificate>
                ) : (
                  <AddEditBinder></AddEditBinder>
                )}
              </CheckForInvalidLink>
            }
            myquotesrightpane={
              <ProspectZoomRightPane
                prospectid={code}
                setCertificate={setViewCertificate}
                viewCertificate={viewCertificate}
                binderDetails={binderDetails}
              ></ProspectZoomRightPane>
            }
            overflowY="auto"
            height="auto"
          ></TwoPanesPanel>
        </MainPane>
      )}
    </GeneralAuthentication>
  );
};

//#region  Left Pane

const ProspectZoomLeftPane = (props) => {
  const binderId = window.location.href.split("=").slice(-1)[0];
  const dispatch = useDispatch();
  const [policyStatus, setPolicyStatus] = useState(null);
  const binderDetails = useSelector(getSelectedBinderDetails);
  const binderPolicyData = useSelector(getSelectedBinderPolicy);
  const policyStatusData = useSelector(getPolicyStatusData);
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference || "en";
  const navigate = useNavigate();
  useEffect(() => {
    if (binderDetails) {
      const prospectid = binderDetails["binderdetails"]["prospectid"];
      dispatch(getClientDetailsUsingProspectId({ prospectid }));
    }
  }, [dispatch]);

  useEffect(() => {
    policyStatusData &&
      policyStatusData?.policystatus?.map((status) => {
        if (status?._id === binderPolicyData?.statusid) {
          setPolicyStatus(status?.value);
        }
      });
  }, [dispatch, policyStatusData]);

  let heightDivison = {
    backtoapp: "1%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "1vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };
  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  // const languagecode = useSelector(getLanguageCode);
  const parentcard = {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "grid",
    gridGap: "1rem",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  };
  const showElements = false;
  return (
    <div>
      <div style={{ marginLeft: "5%", marginTop: "20px" }}>
        <BackToApplication
          text={translations[languagecode].back}
          onClick={() => {
            document.location.href = `/bindpolicies`;
            //navigate(`/bindpolicies`)
          }}
        ></BackToApplication>
      </div>
      <div style={{ display: "flex" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: "5vmin",
            marginLeft: "80px",
            color: theme.COLORS.primary_navyblue,
          }}
        >
          {props.viewCertificate
            ? translations[languagecode]?.certificats
            : translations[languagecode]?.binderInformation}
        </Typography>
        <div
          className="d-flex flex-column text-center"
          style={{
            marginLeft: "20px",
            marginTop: "-20px",
          }}
        >
          <div>{translations[languagecode].status}</div>
          <div
            style={{
              fontSize: "2vmin",
              backgroundColor: theme.COLORS.secondary_orange,
              borderRadius: "15px",
              marginTop: "auto",
              marginBottom: "auto",
              width: "150px",
            }}
            className="py-1"
          >
            <Typography
              style={{
                fontFamily: "GibsonSemiBd",
                fontSize: "2vmin",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              {policyStatus ? policyStatus : "loading"}
            </Typography>
          </div>
        </div>
        <div
          className="d-flex flex-column text-center"
          style={{
            marginLeft: "20px",
            marginTop: "-20px",
          }}
        >
          {showElements ? (
            <>
              <div>Next Action Due Date</div>
              <div
                style={{
                  fontSize: "2vmin",
                  backgroundColor: theme.COLORS.secondary_skyblue,
                  borderRadius: "15px",
                  marginTop: "auto",
                  marginBottom: "auto",
                  width: "230px",
                }}
                className="py-1"
              ></div>
            </>
          ) : null}
        </div>
        <div
          className="d-flex flex-column text-center"
          style={{
            marginLeft: "20px",
            marginTop: "-20px",
          }}
        >
          <div>{translations[languagecode].binderNumber} </div>
          <div
            style={{
              fontSize: "2vmin",
              backgroundColor: "black",
              borderRadius: "15px",
              marginTop: "auto",
              marginBottom: "auto",
            }}
            className="py-1"
          >
            <Typography
              style={{
                fontFamily: "GibsonSemiBd",
                fontSize: "2vmin",
                marginLeft: "35px",
                marginRight: "35px",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              {binderPolicyData ? binderPolicyData?.bindernumber : "loading"}
            </Typography>
          </div>
        </div>
        <div
          className="d-flex flex-column text-center"
          style={{
            marginLeft: "20px",
          }}
        ></div>
      </div>
      <form className="my-2" style={{ width: "100%" }}>
        <div
          className="form-group row"
          style={{
            fontFamily: "GibsonRegular",
            justifyContent: "left",
            fontSize: "0.8vw",
            margin: 0,
            marginLeft: "6%",
          }}
        >
          <label className="col-sm-2 col-form-label text-secondary">
            {translations[languagecode]?.form.clientName}
          </label>
          <label className="col-sm-3 col-form-label">
            {binderDetails
              ? binderDetails["binderdetails"]["CLIENT_NAME"]
              : "-"}
          </label>

          <label className="col-sm-2 col-form-label text-secondary">
            {translations[languagecode]?.form.contactName}
          </label>
          <label className="col-sm-3 col-form-label">
            {binderDetails
              ? binderDetails["binderdetails"]["CLIENT_BUSINESS_NAME"]
              : "-"}
          </label>
        </div>
        <div
          className="form-group row"
          style={{
            fontFamily: "GibsonRegular",
            justifyContent: "left",
            fontSize: "0.8vw",
            margin: 0,
            marginLeft: "6%",
          }}
        >
          <label className="col-sm-2 col-form-label text-secondary">
            {translations[languagecode]?.form.vertical}
          </label>
          <label className="col-sm-3 col-form-label">
            {binderDetails && binderDetails["binderdetails"]["vertical"]
              ? binderDetails["binderdetails"]["vertical"][languagecode]
              : "-"}
          </label>

          <label className="col-sm-2 col-form-label  text-secondary">
            {translations[languagecode]?.form.contactNumber}
          </label>
          <a
            className="col-sm-3 col-form-label"
            href={
              "tel:" +
              (binderDetails
                ? binderDetails["binderdetails"]["CLIENT_CONTACT"]?.replace(
                    /[^0-9]+/g,
                    ""
                  )
                : "-")
            }
          >
            {binderDetails
              ? binderDetails["binderdetails"]["CLIENT_CONTACT"]
              : "-"}
            <Callicon
              height="25px"
              style={{ marginTop: "-5px", marginLeft: "10px" }}
            />
          </a>
        </div>
        <div
          className="form-group row"
          style={{
            fontFamily: "GibsonRegular",
            justifyContent: "left",
            fontSize: "0.8vw",
            margin: 0,
            marginLeft: "6%",
          }}
        >
          <label className="col-sm-2 col-form-label  text-secondary">
            {translations[languagecode]?.form.brokerOwner}
          </label>
          <label className="col-sm-3 col-form-label">
            {binderDetails ? binderDetails["binderdetails"]["brokername"] : "-"}
          </label>

          <label className="col-sm-2 col-form-label  text-secondary">
            {translations[languagecode]?.form.contactEmail}
          </label>
          <a
            className="col-sm-3 col-form-label"
            href={
              "mailto:" +
              (binderDetails
                ? binderDetails["binderdetails"]["CLIENT_EMAIL"]
                : "-")
            }
          >
            {binderDetails
              ? binderDetails["binderdetails"]["CLIENT_EMAIL"]
              : "-"}
            <Mailicon height="30px" style={{ marginTop: "-5px" }} />
          </a>
        </div>
        <div
          className="form-group row"
          style={{
            fontFamily: "GibsonRegular",
            justifyContent: "left",
            fontSize: "0.8vw",
            margin: 0,
            marginLeft: "6%",
          }}
        >
          <label className="col-sm-2 col-form-label  text-secondary">
            {translations[languagecode]?.form.insurer}
          </label>
          <label className="col-sm-3 col-form-label">
            {binderDetails ? binderDetails["binderdetails"]["insurer"] : "-"}
          </label>
        </div>
      </form>
      <div
        style={{
          marginLeft: "100px",
          marginRight: "100px",
          marginTop: "40px",
        }}
      ></div>
    </div>
  );
};

const FormatDateTitle = ({ d }) => {
  let date = new Date(d);
  let dateFormatted = moment(date, "DD/MM/YYYY").format("DD MMM YYYY");
  return (
    <Typography
      style={{
        fontFamily: "GibsonSemiBd",
        fontSize: "2vmin",
        color: "white",
      }}
    >
      {dateFormatted}
    </Typography>
  );
};

const CardTitleDiv = ({ bgColor, title }) => {
  return (
    <div
      style={{
        backgroundColor: bgColor,
        color: "white",
        fontFamily: "GibsonRegular",
        fontSize: "27px",
        fontWeight: "bolder",
        paddingLeft: "10px",
        paddingTop: "5px",
        borderRadius: "3px",
      }}
    >
      {title}
    </div>
  );
};

//#endregion

//#region Right Pane
const ProspectZoomRightPane = (props) => {
  const binderId = window.location.href.split("=").slice(-1)[0];
  const dispatch = useDispatch();
  // let prospectid = props.prospectid;
  const binderFormData = useSelector(getSelectedBinderDetails);
  useEffect(() => {
    if (binderFormData) {
      const prospectid = binderFormData["binderdetails"]["prospectid"];
      dispatch(getClientDetailsUsingProspectId({ prospectid }));
    }
  }, [dispatch]);
  const history = useNavigate();
  const prospectid = props.prospectid;
  const isBinderLetter = useSelector(isBinderLetterModalState);
  const additionalModalState = useSelector(getAdditionalModalState);
  const certificateModalState = useSelector(getCertificateModalState);
  const gotResponseDetails = useSelector(getResponseDetails);
  const asArray = Object.values(gotResponseDetails);
  const validateBeforeSendBind = asArray.filter(
    (data) => data.checkedforcompare === true
  );
  const binderDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const policyStatus = useSelector(getPolicyStatusData);
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference || "en";

  const onConfirmPolicyHandler = () => {
    const confirmStatusId = policyStatus.policystatus.filter(
      (data) => data.name === "CONFIRMED"
    )[0]._id;
    const body = {
      policyId: "",
      statusId: confirmStatusId,
    };
  };
  const onBindModalOpenHandler = () => {
    dispatch(binderLetterModalOpened(true));
  };
  const onCertificateModalOpenHandler = async () => {
    dispatch(certificateDataClear());
    await dispatch(certificateModalOpened());
  };

  const onAdditionalOpenHandler = () => {
    dispatch(certificateFalg({ data: 1 }));
    dispatch(additionalModalOpened());
    dispatch(allCertificateHolderList(binderId));
  };
  let commonActoinMessageButton = {
    height: "25%",
    marginBottom: "2%",
    marginTop: "6%",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingBottom: "17vh",
        paddingTop: "6vh",
        paddingLeft: theme.SCALES.actionPaddingLeft,
        paddingRight: theme.SCALES.actionPaddingRight,
        height: "100%",
      }}
    >
      <ActionCentreText />

      {/* Additional Insureds Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={
            translations[languagecode]?.sideActions.addEditAdditionalInsureds
          }
          buttonText={
            translations[languagecode]?.sideActions.additionalInsureds
          }
          buttonClick={onAdditionalOpenHandler}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
          disabled={!binderFormData}
        />
        <Modal
          isOpen={additionalModalState}
          ariaHideApp={false}
          shouldCloseOnEsc={false}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.COLORS.rgba_primary_navyblue,
              color: "white",
            },
            content: {
              padding: 0,
              height: "820px",
              width: "55vw",
              position: "absolute",
              top: "2vh",
              left: "20vw",
              right: 0,
              bottom: 0,
              background: theme.COLORS.primary_navyblue,
              border: "8px solid white",
              borderRadius: "30px",
            },
          }}
        >
          <AdditionalInsuredsModal
            policyId={binderId}
            binderFormData={binderFormData}
          />
        </Modal>
      </div>

      {/* Create Binder Letter Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode]?.sideActions.createBinderLetter}
          buttonText={
            translations[languagecode]?.sideActions.createBinderLetterButton
          }
          buttonClick={onBindModalOpenHandler}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
          disabled={!binderFormData}
        />
        <Modal
          isOpen={isBinderLetter}
          ariaHideApp={false}
          shouldCloseOnEsc={false}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.COLORS.rgba_primary_navyblue,
              color: "white",
            },
            content: {
              height: "98vh",
              width: "60vw",
              position: "absolute",
              top: "1vh",
              left: "20vw",
              right: 0,
              bottom: 0,
              background: "white",
              WebkitOverflowScrolling: "touch",
              border: `8px solid white`,
              borderRadius: "20px",
              padding: 0,
              overflow: "hidden",
            },
          }}
        >
          <BindLetterModal
            binderFormData={binderFormData}
            binderId={binderId}
          />
        </Modal>
      </div>

      {/* Create Certificate Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode]?.sideActions.createCertificate}
          buttonText={
            translations[languagecode]?.sideActions.createCertificateButton
          }
          buttonClick={onCertificateModalOpenHandler}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
          disabled={!binderFormData}
        />
        <Modal
          isOpen={certificateModalState}
          ariaHideApp={false}
          shouldCloseOnEsc={false}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.COLORS.rgba_primary_navyblue,
              color: "white",
            },
            content: {
              height: "98vh",
              width: "60vw",
              position: "absolute",
              top: "1vh",
              left: "20vw",
              right: 0,
              bottom: 0,
              background: "white",
              WebkitOverflowScrolling: "touch",
              border: `8px solid white`,
              borderRadius: "20px",
              padding: 0,
              overflow: "hidden",
            },
          }}
        >
          <CertificateModal
            binderFormData={binderFormData}
            binderId={binderId}
          />
        </Modal>
      </div>

      {/* View and Manage Certificates Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={
            !props.viewCertificate
              ? translations[languagecode]?.sideActions.viewManageCertificates
              : null
          }
          buttonText={
            props.viewCertificate
              ? translations[languagecode]?.sideActions.binderSummary
              : translations[languagecode]?.sideActions.certificateHub
          }
          buttonClick={() => {
            props.viewCertificate === false
              ? props.setCertificate(true)
              : props.setCertificate(false);
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        />
      </div>

      {/* Go to Application Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode]?.sideActions.visitApplication}
          buttonText={translations[languagecode]?.sideActions.goToApplication}
          buttonClick={() => {
            document.location.href = `/questions?id=${props.binderDetails?.binderdetails?.prospectid}`;
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        />
      </div>

      {/* Go to Transactions and Documents Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode]?.sideActions.reviewTransactions}
          buttonText={
            translations[languagecode]?.sideActions.goToTransactionsAndDocuments
          }
          buttonClick={() => {
            document.location.href = `/prospect?id=${props.binderDetails?.binderdetails?.prospectid}`;
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        />
      </div>
    </div>
  );
};
export default BinderZoom;
